import Info from '@components/Info';
import Button from '@components/UI/Button';
import Container from '@components/UI/Container';
import Icon from '@components/UI/Icon';
import TimeCounter from '@components/UI/TimeCounter';
import Paragraph from '@components/UI/Typography/Paragraph';
import useUtmTags, { Utm } from '@hooks/useUtmTags';

import css from '@utils/css';

import React from 'react';


export const BannerCTA = () => (
  <div className="my-8 md:my-16">
    <Container>
      <Info
        mods={ { center: true } }
        className={ css('relative flex flex-col gap-4 justify-center text-center p-8 md:p-12 xl:p-16') }
      >
        <div
          className='absolute left-0 top-0 bg-white h-full w-full overflow-hidden -z-[1] rounded-16p'
        >
          <div
            className='radials radials_gradient_third w-[1716px] h-[1716px]'
          >
          </div>
          <div
            className='radials w-[960px] h-[960px]'
          >
          </div>
          <div
            className='radials radials_gradient_first w-[600px] h-[600px]'
          >
          </div>
        </div>
        <div className='flex justify-center'>
          <TimeCounter />
        </div>
        <div>
        <div
          className='text-28p font-[700] leading-40p lg:text-40p lg:leading-56p lg:-tracking-[1px]'
        >
          Start tracking time
        </div>
        </div>
        <div className={ css('flex flex-col gap-4 justify-center max-sm:w-full') }>
          <Button
            tag='a'
            type='link'
            href={ useUtmTags(`${process.env.NEXT_PUBLIC_APP_TRAQQ_URL}/signup`,
              {
                utm_campaign: Utm.CAMPAIGN.BUTTON,
                utm_term: 'Register for free'
              }) }
            variant='primary'
            size='lg'
            mods={ { 'no-spacing': true } }
            className={ 'max-sm:w-full self-center' }
          >
            Register for free
          </Button>
          <span className={ css('flex items-center justify-center text-neutral-600 gap-2') }>
                        <Icon
                          name='card' color='#7F818F' size={ 24 }
                        />
                        No credit card required
                    </span>
        </div>
      </Info>
    </Container>
  </div>
);
